import { APIClient } from '@frontend/api-utils';

export class AccountEnumClient extends APIClient {
    public static readonly endpoint = '/account-api/v1';

    public static async fetchInitializeApplications(): Promise<string[]> {
        const res = await this.fetch(`${this.endpoint}/account-initialize-applications`);
        return await this.handleResponse<string[]>(res);
    }

    public static async fetchInitializeCustomers(): Promise<string[]> {
        const res = await this.fetch(`${this.endpoint}/account-initialize-customers`);
        return await this.handleResponse<string[]>(res);
    }
}
